export const hasTouch = (): boolean => {
	return !!(
		'ontouchstart' in window ||
		'ontouchstart' in document.documentElement ||
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		navigator.msMaxTouchPoints
	);
};

export const smoothScrollToTop = () => {
	window &&
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
};

export const scrollToAnchor = () => {
	if (window.location.hash) {
		const targetElement = document.querySelector(window.location.hash);
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	}
};

/**
 * Initilize the breakpoint watcher and return the actual breakpoint
 * @param callback {Function} media query listener callback
 * @param breakpoints {Object} breakpoint config
 * @returns {string}
 */
export const detectBreakpoint = (
	mqChangeHandler,
	breakpoints = [
		{ mq: null, name: 'mobile' },
		{ mq: window.matchMedia('(min-width: 768px)'), name: 'tablet' },
		{ mq: window.matchMedia('(min-width: 1024px)'), name: 'desktop' }
	]
) => {
	breakpoints.forEach(({ name, mq }) => {
		if (mq) {
			try {
				mq.addEventListener('change', () => mqChangeHandler(breakpoints));
			} catch (e) {
				try {
					// Safari 12 compliant
					mq.addListener(mqChangeHandler(breakpoints));
				} catch (e) {
					console.error(e);
				}
			}
		}
	});

	return breakpoints;
};
